import { Point } from "../shared/Point";
import { useLocalization } from "../../hooks/useLocalization";

const POINT_IMAGES = [
  {
    key: "ONE" as const,
    file: "game.jpg",
    alt: "Group of players playing on computer",
    reverse: false,
    trimMobile: true,
  },
  {
    key: "TWO" as const,
    file: "trophy.jpg",
    alt: "Group of players holding a trophy",
    reverse: true,
  },
  {
    key: "THREE" as const,
    file: "audience.jpg",
    alt: "People watching game live in a studio",
    reverse: false,
    trimMobile: true,
  },
];

export const Points = () => {
  const { strings } = useLocalization();
  const copy = strings.ABOUT.POINTS;
  const imgs = import.meta.env.VITE_S3_ASSET_URL;

  return (
    <section aria-labelledby="about-points-title">
      <header className="about-section-header">
        <span className="about-section-eyebrow">{copy.EYEBROW}</span>
        <h2 id="about-points-title">{copy.SECTION_TITLE}</h2>
        <p className="about-section-subtitle">{copy.SECTION_SUBTITLE}</p>
      </header>

      <div className="flex flex-col gap-5 max-md:gap-6">
        {POINT_IMAGES.map((item) => {
          const content = copy[item.key];
          return (
            <Point
              key={item.key}
              img={`${imgs}/images/${item.file}`}
              paragraph={content.PARAGRAPH}
              header={content.TITLE}
              alt={item.alt}
              reverse={item.reverse}
              trimMobile={item.trimMobile}
            />
          );
        })}
      </div>
    </section>
  );
};
